const main = require('./main');

module.exports = main;
if (process.env.NODE_ENV === 'development') {
  main.init();
}
if (process.env.NODE_ENV === 'development-external') {
  if (!window['raq-iu']) {
    window['raq-iu'] = {};
  }
  window['raq-iu'] = main;
}
